import * as React from 'react';
import { Label, Input, Row, Col } from 'reactstrap';
import { getValue } from '../../core/lodash';

interface ICheckboxGridProps {
  questions: object;
}

const CheckboxGrid: React.FunctionComponent<ICheckboxGridProps> = (props) => {
  return (
    <>
      <table className="table table-borderless">
        {getValue(props.questions, `row`, []).map((rowData, i) => {
          return (
            <>
              {i === 0 ? (
                <thead>
                  <tr>
                    <td></td>
                    {getValue(props.questions, `columns`, []).map((item) => {
                      return (
                        <td className="text-center">
                          <p className="mb-0 ">
                            {getValue(item, `text`, '')}
                          </p>
                        </td>
                      );
                    })}
                  </tr>
                </thead>
              ) : (
                ''
              )}
              <tbody>
                <tr>
                  <td>
                    <p className="mb-0 ">
                      {getValue(rowData, 'text', '')}
                    </p>
                  </td>
                  {getValue(rowData, 'columns', '').map((item, _index) => {
                    let a = getValue(props, 'questions.response', []).filter(
                      (items) => {
                        return (
                          items.rowId === rowData.id &&
                          item.id === items.columnId &&
                          items.columnId !== ''
                        );
                      }
                    );
                    return (
                      <td className="text-center">
                        <div className="form-group mb-0">
                          <Label className="checkbox-container d-inline-block pl-4 ml-1">
                            <Input
                              type="checkbox"
                              placeholder="Enter here"
                              checked={a.length > 0}
                              // onChange={() => {
                              //   props.handleUserSurveyResponseDropdownGrid(
                              //     getValue(selected[0], 'questionId', ''),
                              //     getValue(props.questions, 'type', ''),
                              //     rowData.id,
                              //     item.id
                              //   );
                              // }}
                            />
                            <span className="checkmark"></span>
                          </Label>
                        </div>
                      </td>
                    );
                  })}
                </tr>
              </tbody>
            </>
          );
        })}
      </table>
      {/* <PreviewAdvancedOptions
      questions={props.questions}
      answer={props.answer}
      handleChangeTakeSurveyAdvancedOptionInput={
        props.handleChangeTakeSurveyAdvancedOptionInput
      }
    /> */}

      {/* <div className="form-error" style={{ color: 'red' }}>
      {props.requiredErrors.includes(getValue(props, 'questions.id', ''))
        ? getValue(props.questions, 'mandatoryMsg', '')
        : ''}
    </div> */}
    </>
  );
};

export default CheckboxGrid;
